
export default function filterById(jsonObject, label, value ) {
    return jsonObject.filter(
        function(jsonObject) {
            return (jsonObject[label] === value);
        })[0];
}